/* eslint-disable no-restricted-imports */
import MuiCheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import MuiErrorIcon from '@mui/icons-material/Error';
import MuiInfoIcon from '@mui/icons-material/Info';
import MuiWarningIcon from '@mui/icons-material/Warning';
import { SvgIconProps } from '@mui/material';

import { iconGrey } from '@/theme';

/**
 * We flip mui's definition of "error" and "warning" icons, so we route all references to these icons through here to help
 * stay consistent.
 */

export const WarningIcon = (props: SvgIconProps) => <MuiErrorIcon color="warning" {...props} />;
export const ErrorIcon = (props: SvgIconProps) => <MuiWarningIcon color="error" {...props} />;
export const InfoIcon = (props: SvgIconProps) => <MuiInfoIcon htmlColor={iconGrey} {...props} />;
export const SuccessIcon = (props: SvgIconProps) => <MuiCheckCircleIcon color="success" {...props} />;
export const TipIcon = (props: SvgIconProps) => <EmojiObjectsOutlinedIcon color="info" {...props} />;
